import { createFileRoute } from '@tanstack/react-router';
import { PendingApprovalsPage } from '@/pages/staffing/PendingApprovalsPage';

export const Route = createFileRoute('/_authenticated/_app/staffing/pending-approvals')({
	component: PendingApprovalsPage,
});
